export const formatNumber = (num) => {
  if (!num && num !== 0) return '';
  return new Intl.NumberFormat('en-IN').format(num);
};

export const parseNumber = (value) => {
  return Number(value.replace(/,/g, '')) || 0;
};

const helperFunctions = { formatNumber, parseNumber };
export default helperFunctions;
export const pr = (value) => {
  return Number(value.replace(/,/g, '')) || 0;
};
